import React from 'react';

/*
 * Компонент берёт `IconCollection` ОБЩУЮ, а не собранную приложением
 * (`{ ...sharedIcons, ...appIcons }`): пакет о расширении приложения не знает.
 * Используемые здесь `trashCan` и `trashCanThin` входят в общий набор, так что
 * разницы нет. Но если приложение когда-нибудь перекроет эти имена в своём
 * `appIcons.ts`, `DeleteIcon` из пакета продолжит рисовать общую иконку —
 * тогда компонент придётся параметризовать, а не чинить оверрайдом.
 */

import { CoreIcon } from '../../primitives/CoreIcon';
import { IconCollection } from '../IconCollection';

import type { DeleteIconProperties } from './DeleteIcon.types';

export const DeleteIcon: React.FC<DeleteIconProperties> = ({
  dataTest = 'delete_icon',
  onClick,
  color = 'error',
  sx,
  variant,
  isDisabled,
}) => {
  return (
    <CoreIcon
      dataTest={dataTest}
      icon={
        variant === 'thin'
          ? IconCollection.trashCanThin
          : IconCollection.trashCan
      }
      onClick={onClick}
      color={color}
      sx={sx}
      isDisabled={isDisabled}
    />
  );
};
